import { BAH_CHILD_DATAMEMBER, BAH_CHILD_RECORD_ID } from '../../constants/runtime.constants';

export const normalizeAttachmentData = ({
  uploadData,
  rowId,
  PARENT_PK_ID,
  formInfo,
  gridId,
  parentData,
}) => {
  const attachmentObj = {
    BAH_ID: rowId,
    BAH_OWNER_ID: PARENT_PK_ID || 'NR_1',
    BAH_ORG_ID: formInfo.userContext?.f_CurrentOrgUnitID,
    BAH_CREATED_DATE: uploadData.ACO_CREATED_DATE,
    BAH_CREATED_BY: uploadData.ACO_CREATED_BY,
    BAH_MODIFIED_DATE: uploadData.ACO_CREATED_DATE,
    BAH_MODIFIED_BY: uploadData.ACO_CREATED_BY,
    BAH_STEP_NAME: formInfo.stepName,
    BAH_STEP_ID: formInfo.stepId,
    BAH_WFE_ID: formInfo.workflowId,
    BAH_WORKFLOW_KEY: formInfo.workflowKey,
    BAH_DESCRIPTION: '',
    ACO_ID: uploadData.ACO_ID,
    ACO_ORG_ID: formInfo.userContext?.f_CurrentOrgUnitID,
    ACO_BAH_ID: rowId,
    ACO_FILE_NAME: uploadData.ACO_FILE_NAME,
    ACO_CREATED_DATE: uploadData.ACO_CREATED_DATE,
    ACO_CREATED_BY: uploadData.ACO_CREATED_BY,
    ACO_MODIFIED_DATE: uploadData.ACO_CREATED_DATE,
    IsNewObject: true,
    IsExistingObject: false,
    BAH_ACO_TEMP_ID: uploadData.ACO_ID,
    ContainerInstanceIdForHandMadeNewObject: gridId,
  };

  if (parentData) {
    attachmentObj[BAH_CHILD_RECORD_ID] = parentData.parentRowId;
    attachmentObj[BAH_CHILD_DATAMEMBER] = parentData.parentEntityName;
  }

  return attachmentObj;
};
